/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BasicInfo
 */
export interface BasicInfo {
    /**
     * 
     */
    branch: string;
    /**
     * HCHB branch external_id (for example FHH), used to load payor forms.
     */
    branch_code?: string;
    /**
     * 
     */
    team: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    first_name: string;
}

/**
 * Check if a given object implements the BasicInfo interface.
 */
export function instanceOfBasicInfo(value: object): value is BasicInfo {
    if (!('branch' in value) || value['branch'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    return true;
}

export function BasicInfoFromJSON(json: any): BasicInfo {
    return BasicInfoFromJSONTyped(json, false);
}

export function BasicInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasicInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'branch': json['branch'],
        'branch_code': json['branch_code'] == null ? undefined : json['branch_code'],
        'team': json['team'],
        'last_name': json['last_name'],
        'first_name': json['first_name'],
    };
}

export function BasicInfoToJSON(json: any): BasicInfo {
    return BasicInfoToJSONTyped(json, false);
}

export function BasicInfoToJSONTyped(value?: BasicInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branch': value['branch'],
        'branch_code': value['branch_code'],
        'team': value['team'],
        'last_name': value['last_name'],
        'first_name': value['first_name'],
    };
}

